/**
 * Middleware to clear all snackbars when navigating between routes.
 *
 * @param {Object} to - The route being navigated to
 * @param {string} to.path - Path of the destination route
 * @param {Object} from - The route being navigated from
 * @param {string} from.path - Path of the origin route
 * @param {string} from.name - Name of the origin route
 *
 * @returns {void}
 *
 * @description
 * - Clears all snackbars when the route path changes
 * - Prevents snackbars from persisting across different pages
 * - Excludes clearing snackbars for specific checkout routes
 *
 * @remarks
 * - Uses the `useHeaderSnackbars()` composable to manage snackbar state
 * - Skips clearing snackbars for Adyen and PayPal checkout routes
 *
 * @example
 *  When navigating from '/home' to '/products'
 *  Clears all snackbars
 *
 *  When navigating within checkout routes
 *  Does not clear snackbars
 */
export default defineNuxtRouteMiddleware((to, from) => {
  const { clearAllSnackbars } = useHeaderSnackbars()
  if (
    from.path !== to.path &&
    from.name !== 'localized-checkout-adyen' &&
    from.name !== 'localized-checkout-paypal'
  ) {
    clearAllSnackbars()
  }
})
